export default "__VITE_ASSET__C$0Rch3P__"